<template>
  <div>
    <PageHead title="查看回复"></PageHead>
    <div class="oa-layout-content">
      <div class="mb20 search-btns mt20">
        <!-- <a-button type="primary" @click="goDetial()" icon="plus">
          发送通知</a-button
        > -->
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>

      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record)">
            查看
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    scopedSlots: { customRender: "index" },
    width: 80,
  },

  {
    title: "标题",
    dataIndex: "titleName",
    key: "titleName",
    ellipsis: true,
  },

  {
    title: "回复时间",
    dataIndex: "replyTime",
    key: "replyTime",
    ellipsis: true,
  },
  {
    title: "回复部门",
    dataIndex: "replyDepartmentName",
    key: "replyDepartmentName",
    ellipsis: true,
  },
  {
    title: "回复人",
    dataIndex: "replyPerson",
    key: "replyPerson",
    ellipsis: true,
  },
  {
    key: "operation",
    scopedSlots: { customRender: "action" },
    title: "操作",
    align: "left",
    width: 80,
  },
];

import { replyDetails } from "./api/api";
export default {
  data() {
    return {
      id: "",
      queryForm: {},
      data: [{}],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false,
    };
  },

  created() {
    this.id = this.$route.query.id;
    this.load();
  },
  methods: {
    // 拉取列表
    load() {
      this.loading = true;
      let params = this.queryForm;
      params.id = this.id;
      params.page = this.page;
      params.size = this.size;
      replyDetails(params).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          this.data = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    goDetial(item) {
      const { href } = this.$router.resolve({
        path: "/AccountingComputerizationNoticeReply",
        query: {
          id: item.id,
          isEdit: "1",
          isLook: "1",
          partyNoticeId: item.partyNoticeId,
        },
      });
      window.open(href, "_self");
    },
    pageChange(pageber) {
      this.page = pageber;
      this.load();
    },
    cancel() {
      //取消
      this.queryForm = {};
    },
    subMit() {
      this.page = 1;
      this.load();
    },
  },
};
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/AccountingComputerizationNotice/replied.vue